import React, { useState, useEffect } from 'react'
import { Column, Columns } from '@resurs/midas-react'
import { midas } from '@resurs/midas'
import shortid from 'shortid'
import NumberFormat from 'react-number-format'
import moment from 'moment'
import { Countries } from '@merchant-portal/mp-models'
import { useLocaleState } from '@merchant-portal/merchant-portal-base'
import { getText } from '../../../../internal/TextLabels'
import { PaymentPerMonthCard } from './PaymentPerMonthCard'
import styles from './PaymentPerMonthOptions.module.scss'

export const PaymentPerMonthOptions = ({
  methodId,
  description,
  cost,
  costLoading,
  amount,
}) => {
  const [baseOptions, setBaseOptions] = useState([])
  const [flexOptions, setFlexOptions] = useState([])
  const { country } = useLocaleState()

  useEffect(() => {
    if (!cost || cost.length === 0) {
      return
    }

    const filteredAndSortedBaseOptions = cost
      .filter(costOption => costOption.type === 'BASE')
      .sort((a, b) => a.months - b.months)
      .map(arr => ({
        id: shortid.generate(),
        value: arr,
      }))
    const filteredAndSortedFlexOptions = cost
      .filter(costOption => costOption.type === 'FLEX')
      .sort((a, b) => a.months - b.months)
      .map(arr => ({
        id: shortid.generate(),
        value: arr,
      }))

    setBaseOptions(filteredAndSortedBaseOptions)
    setFlexOptions(filteredAndSortedFlexOptions)
  }, [cost])
  return (
    <div className={styles.paymentPerMonthOptionsContainer}>
      <Columns>
        {baseOptions && baseOptions.length > 0 && (
          <>
            <Column col12>
              {methodId && (
                <div className={styles.paymentPerMonthHeader}>
                  <h2>
                    {description}{' '}
                    {costLoading && (
                      <div
                        className={`${midas.loading} ${styles.loadingSpinner}`}
                      />
                    )}
                  </h2>
                  <p>
                    {getText('payApply.paymentPerMonth.headerSubtitle')}
                    {': '}
                    <span>
                      <NumberFormat
                        value={amount}
                        displayType="text"
                        thousandSeparator=" "
                        decimalScale={2}
                        renderText={val => getText('default.currency', val)}
                      />
                    </span>
                  </p>
                </div>
              )}
            </Column>
            {!costLoading &&
              baseOptions.map(option => (
                <PaymentPerMonthCard
                  option={option}
                  key={option.id}
                  amount={amount}
                />
              ))}
          </>
        )}

        {!costLoading && flexOptions && flexOptions.length > 0 && (
          <>
            <Column col12>
              <h2>{getText('payApply.paymentPerMonth.flexTitle')}</h2>
              <p className={styles.paragraph}>
                {getText('payApply.paymentPerMonth.flexDescription')}
              </p>
            </Column>
            {flexOptions.map(option => (
              <PaymentPerMonthCard
                option={option}
                key={option.id}
                amount={amount}
              />
            ))}
          </>
        )}
        {!costLoading && cost && (
          <Column col12>
            <div className={styles.reservationsContainer}>
              <ul>
                <li>
                  {getText('payApply.paymentPerMonth.updatedAt')}{' '}
                  {moment().format('dddd LL')}.
                </li>
                <li>{getText('payApply.paymentPerMonth.firstReservation')}</li>
                {country !== Countries.FI && (
                  <li>
                    {getText('payApply.paymentPerMonth.secondReservation')}
                  </li>
                )}
              </ul>
            </div>
          </Column>
        )}
      </Columns>
    </div>
  )
}
